'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileUAParts = require('./parts/MobileUAParts');

var _MobileUAParts2 = _interopRequireDefault(_MobileUAParts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Grabbed from https://gist.github.com/dalethedeveloper/1503252
var MOBILE_UA_REGEX = new RegExp('Mobile|' + _MobileUAParts2.default.ios + '|' + _MobileUAParts2.default.android + '|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune');

exports.default = MOBILE_UA_REGEX;
module.exports = exports['default'];